import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { Button } from 'components/Elements';

/*
Load all background images starting with bg_
*/
const importAll = (r) => r.keys().map(r);

const bgImages = importAll(require.context('assets/bg', false, /^\.\/bg_.*\.(png|jpg|jpeg|webp)$/));

export const Hero = ({ user, onStart }) => {
  const bg = useMemo(() => {
    const index = Math.floor(Math.random() * bgImages.length);
    return bgImages[index];
  }, []);

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Dynamic background */}
      <img
        src={bg}
        alt=""
        className="absolute inset-0 w-full h-full object-cover brightness-50 scale-105"
      />

      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 max-w-4xl text-center px-6"
      >
        <h1 className="just-me text-5xl md:text-7xl font-extrabold">
          Build Stanning Websites In seconds
        </h1>

        <p className="mt-6 text-lg text-slate-300">
          Build websites, deploy CMS infrastructure and extend them with powerful integrations and
          custom features.
        </p>

        <div className="mt-10 flex gap-4 justify-center">
          <Button size="lg" onClick={onStart}>
            {user ? 'Open Console' : 'Start Building'}
          </Button>
        </div>
      </motion.div>
    </section>
  );
};
